import React, { useEffect } from 'react';
import { MenuItem, Select } from '@material-ui/core';
import CommonContainer from '../../containers/Common';
import { Field } from 'formik';

interface Props {
  meganetFrameMasterId: number,
  onChange: (meganetFrameMasterId: number) => void,
}

export default ((props) => {
  const commonContainer = CommonContainer.useContainer();
  const frames = commonContainer.getFrames();
  const meganetFrameMasterId = commonContainer.getFrameByFrameMasterId(props.meganetFrameMasterId) ? props.meganetFrameMasterId : -1;

  useEffect(() => {
    if (props.meganetFrameMasterId === undefined) {
      props.onChange(meganetFrameMasterId);
    }
  }, [commonContainer, meganetFrameMasterId, props]);

  return (
    <Field style={{ fontSize: 13, maxWidth: 160, }} required fullWidth name='Frame' label='Frame' id='Frame' value={meganetFrameMasterId} onChange={(event: React.ChangeEvent<HTMLSelectElement>) => props.onChange(Number(event.target.value))} component={Select} >
      <MenuItem style={{ height: 30, }} key={-1} value={-1}>メーカー加工対象外</MenuItem>
      {frames.map(frame => (
        <MenuItem key={frame.meganetFrameMasterId} value={frame.meganetFrameMasterId}>{frame.frameName}</MenuItem>)
      )}
    </Field >
    );
}) as React.FC<Props>;